import React from 'react';
import { Link } from 'react-router-dom';
import { Baby, Heart, Apple, Dumbbell, Droplet, ArrowRight, CheckCircle } from 'lucide-react';
import { programs } from '../../data/mock';

const iconMap = { Baby, Heart, Apple, Dumbbell, Droplet };

const ProgramsSection = () => {
  return (
    <section
      id="programs"
      className="py-16 sm:py-20 lg:py-24 relative overflow-hidden bg-slate-950"
      data-testid="programs-section"
    >
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl" aria-hidden="true"></div>
      <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-emerald-600/10 rounded-full blur-3xl" aria-hidden="true"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full text-blue-400 text-sm font-medium mb-4">
            Our Programs
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Programs <span className="bg-gradient-to-r from-blue-400 via-orange-400 to-emerald-400 bg-clip-text text-transparent">Built Around You</span>
          </h2>
          <p className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto px-4">
            Choose a personalized program designed by healthcare professionals.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {programs.map((program) => {
            const Icon = iconMap[program.icon];
            return (
              <div
                key={program.id}
                className="bg-slate-900/50 backdrop-blur-sm rounded-2xl overflow-hidden border border-slate-800 hover:border-slate-600 transition-all flex flex-col"
                data-testid={`program-card-${program.id}`}
              >
                <div className={`bg-gradient-to-br ${program.gradient} p-5`}>
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-3">
                    {Icon && <Icon className="w-6 h-6 text-white" aria-hidden="true" />}
                  </div>
                  <h3 className="text-lg font-bold text-white leading-tight">{program.name}</h3>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <ul className="space-y-2.5 mb-6 flex-1">
                    {program.bullets.map((b, i) => (
                      <li key={i} className="flex items-start gap-2 text-slate-400 text-sm leading-relaxed">
                        <CheckCircle className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" aria-hidden="true" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={program.slug}
                    className="inline-flex items-center justify-center gap-1.5 bg-slate-800 hover:bg-slate-700 text-white px-4 py-2.5 rounded-full text-sm font-semibold transition-colors w-full"
                    data-testid={`program-learn-more-${program.id}`}
                  >
                    Learn More
                    <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;
